import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { FullScreen, useFullScreenHandle } from 'react-full-screen';import Bar from './../components/Bar';
import Map from './../components/Map';
import Result from './../components/Result';
import Filter from './../components/Filter';
import { useMediaQuery } from 'react-responsive';
import MARInput from '../components/MARInput';
import Footer from '../components/Footer';
import Header from '../components/Header';

function Home() {
    const [mapFullScreen, setMapFullScreen] = useState(false);
    const handle = useFullScreenHandle();
    const [showFilter, setShowFilter] = useState(true);
    const isMobile = useMediaQuery({ query: `(max-width: 767px)` });
    const { t } = useTranslation();

    function toggleFilterOnMobileHandler(evt) {
        if (isMobile) {
            setShowFilter(evt);
        } else {
            setShowFilter(true);
        }
    }

    useEffect(() => {
        if (!isMobile) {
            setShowFilter(true);
        } else {
            setShowFilter(false);
        }
    }, [isMobile]);

    function fullScreenSwitch(){
        if (mapFullScreen) {
            handle.exit();
        } else {
            handle.enter();
        }
        setMapFullScreen(!mapFullScreen);
    }

    return (
        <div className="container max-w-[1200px] mx-auto md:px-4 mb-[-91px]">
            <Header></Header>
            <div className="border-2 border-[#97AFB4]">
                <Bar onToggleFilterOnMobile={(evt)=> toggleFilterOnMobileHandler(evt)} />
                <div className="flex flex-row flex-wrap relative">
                    <aside className="w-full md:w-1/3 lg:w-1/4 bg-my-gray">
                        {
                            showFilter && <Filter />
                        }
                    </aside>
                    <main role="main" className="w-full md:w-2/3 lg:w-3/4 border-l-[2px] border-[#97afb4] print:border-0 flex flex-col">
                        {
                            (isMobile) && <div className="block p-[6px] bg-white mt-2">
                                <p className="text-my-emerald text-[12px] leading-tight font-extrabold mb-2 ml-1">{t('filter.address.title')}</p>
                                <MARInput></MARInput>
                            </div>
                        }
                        <div className='relative h-72 lg:h-[400px] print:h-[400px] print:border-[#97AFB4] print:border-b'>
                            <FullScreen handle={handle}>
                                <Map />
                                <div onClick={() => fullScreenSwitch()} className="absolute top-1 right-1 z-[500] cursor-pointer w-8 h-8 border border-gray-200 bg-white text-gray-600 shadow-md print:hidden ">
                                    <div className="flex flex-col h-full justify-center items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={"w-6 h-6 " + (!mapFullScreen ? 'show' : 'hidden') }>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={"w-6 h-6 " + (mapFullScreen ? 'show' : 'hidden') }>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 9V4.5M9 9H4.5M9 9L3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5l5.25 5.25" />
                                        </svg>
                                    </div>
                                </div>
                            </FullScreen>
                        </div>
                        <Result />
                    </main>
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
}


export default Home;
